import { render } from "./RowCheckbox.vue?vue&type=template&id=a9cab39a"
import script from "./RowCheckbox.vue?vue&type=script&lang=js"
export * from "./RowCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script